import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { Hex, zeroAddress } from 'viem'
import { useConfig } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { signTypedDataMutationOptions } from 'wagmi/query'

import { ConnectReferralCodeArgs } from './useConnectReferralCode'
import { verifyReferralCode } from './verifyReferralCode'

export function useSignReferralCodeData({
  onError,
}: {
  onError: () => void
}): UseMutationResult<Hex, Error, ConnectReferralCodeArgs> {
  const config = useConfig()
  const { mutationFn, mutationKey } = signTypedDataMutationOptions(config)

  return useMutation({
    mutationKey,
    mutationFn: async (args: ConnectReferralCodeArgs) => {
      await verifyReferralCode(args)
      return mutationFn(getSignReferralCodeDataConfig(args))
    },
    onError,
  })
}

function getSignReferralCodeDataConfig({
  account,
  referralCode,
}: ConnectReferralCodeArgs): Parameters<ReturnType<typeof signTypedDataMutationOptions>['mutationFn']>[0] {
  return {
    types: signReferralCodeDataTypes,
    domain: {
      name: 'Spark',
      version: '1',
      chainId: mainnet.id,
      verifyingContract: zeroAddress,
    },
    primaryType: 'Payload',
    message: {
      invite_referral_code: referralCode,
      invitee: account,
    },
  }
}

const signReferralCodeDataTypes = {
  Payload: [
    { name: 'invite_referral_code', type: 'string' },
    { name: 'invitee', type: 'address' },
  ],
} as const
